module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-2-3068e5e30d16e3ea6a085f04e526769e.jpg";